export default class ServerError extends Error {
  constructor({
    status,
    code,
    stack = null,
    message,
    exception = null,
    trace = null
  }) {
    super();
    this.name = "";
    this.type = "ServerError";
    this.message = message;
    this.status = status;
    this.code = code;
    this.exception = exception;
    this.trace = trace;
    this.code = code;
    this.stack = stack;
  }
}
